<template>
    <div>
        <v-row class="d-flex flex-row pa-5" v-if="!loading">
            <v-col cols="12" md="12" class="d-flex flex-row justify-start font-weight-regular ">
                <v-icon color="red" class="mr-5">mdi-map-marker-outline</v-icon>
                <div class="font-weight-bold text-body-1">
                    {{ calleAfi }} {{ nroAfi }}, {{ desprovAfi.toUpperCase() }} {{ localidadAfi }}
                </div>
            </v-col>
            <v-col cols="12" md="12" class="d-flex flex-row justify-start">
                <v-icon class=" mr-5" color="green">mdi-phone-outline</v-icon>
                <div class="font-weight-bold text-body-1">{{ telefonoAfi }}
                </div>
            </v-col>
            <v-col cols="12" md="12" class="d-flex flex-row justify-start">
                <v-icon class="mr-5" color="indigo">mdi-email-outline</v-icon>
                <div class="font-weight-bold text-body-1">
                    {{ emailAfi }}
                </div>
            </v-col>
            <v-card-text class="d-flex flex-column justify-center align-center py-2">
                <v-btn @click="datosCorrectos" class="elevation-0 py-5" width="250" color="primary">Mis datos son
                    correctos</v-btn>
                <v-btn class="elevation-0 py-5 mt-2" @click="goToListarContactos" width="250" color="secondary"
                    outlined>modificar
                    datos</v-btn>
            </v-card-text>
        </v-row>
        <v-row v-else style="width: 100%;">
            <v-col cols="12" md="12" class="justify-center">
                <v-skeleton-loader type="text" class="mt-5 mb-2"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="12" class="  justify-start">
                <v-skeleton-loader type="text" class="mb-2"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="12" class="justify-center">
                <v-skeleton-loader type="text" class="mb-2"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="12" class="d-flex flex-row justify-center">
                <v-skeleton-loader type="button"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" class="d-flex flex-row justify-center">
                <v-skeleton-loader type="button"></v-skeleton-loader>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    name: 'FormActualizarContacto',
    components: {
    },
    props: {

    },
    data() {
        return {
            telefonoAfi: '',
            calleAfi: '',
            nroAfi: '',
            localidadAfi: '',
            desprovAfi: '',
            emailAfi: '',

            loading: true,
        }
    },
    computed: {
        ...mapGetters(['telefono', 'email', 'domicilio', 'telefonoPrinc', 'emailPrinc', 'domicilioPrinc']),
    },

    /* 
     nº ${ this.domicilioPrinc.nro } ${ this.domicilioPrinc.desprov } - ${ this.domicilioPrinc.localidad }
      */

    async mounted() {
        try {
            // Espera a que las acciones asíncronas se completen
            await this.getEmail();
            await this.getTelefono();
            await this.getDomicilio();

            // Asigna los datos después de que las acciones se completen
            this.telefonoAfi = `${this.telefonoPrinc.carac} ${this.telefonoPrinc.telefono}`;
            this.emailAfi = this.emailPrinc.email;
            this.calleAfi = `${this.domicilioPrinc.calle}`;
            this.nroAfi = `${this.domicilioPrinc.nro}`;
            this.localidadAfi = `${this.domicilioPrinc.localidad}`;
            this.desprovAfi = `${this.domicilioPrinc.desprov}`;
        } catch (error) {
            console.error('Error al cargar los datos:', error);
            this.showSnack({
                message: 'Error al cargar los datos de contacto.',
                type: '400',
            });
        } finally {
            // Desactiva el loading después de completar las acciones
            this.loading = false;
        }
    },
    methods: {
        ...mapActions(['getEmail', 'getTelefono', 'getDomicilio']),
        ...mapActions('auth', ['datosValidos']),

        formatoYValidacion() {
            const car = this.carac.length
            const num = this.nrotelefono.length
            if ((car + num !== 10) && (this.camposCompletos)) {
                this.showSnack({
                    message: 'La totalidad del número telefonico (prefijo y número) debe ser igual a 10 caractéres.',
                    type: '400'
                })
                this.telefonoAfi = ''
            } else if (this.camposCompletos) {
                this.carac = this.carac.replace(/\D/g, '');
                this.nrotelefono = this.nrotelefono.replace(/\D/g, '');
                this.telefonoAfi = `${this.carac} ${this.nrotelefono}`
            }
        },
        goToListarContactos() {
            this.$emit('cerrarDialogo')
            this.$router.push('/ListarContactos').catch(() => { });
        },
        datosCorrectos() {
            this.$emit('cerrarDialogo')
            this.datosValidos()
        }


    }
}

</script>